export enum EventFilterStatus {

  All = 0,
  AvailableForUser = 5,
  Confirmed = 10,
  Canceled = 15,
  History = 20

}
